import React from 'react';

import { ColorModeSelector } from '@fragment/ui/src/components/ColorMode/ColorModeSelector';
import { Toggle } from '@fragment/ui/src/components/Toggle/Toggle';

import { useShowArchivedPreference } from '../../../../hooks/useShowArchivedPreference';

export const Preferences = () => {
  const { showArchived, setShowArchived } = useShowArchivedPreference();

  return (
    <div>
      <div className="pb-f4">
        <span className="text-main">Preferences</span>
      </div>
      <div className="space-y-f3">
        <div>
          <span className="text-main-500">Theme</span>
          <ColorModeSelector />
        </div>
        <div>
          <span className="text-main-500">Archived entries</span>
          <Toggle
            controlled
            activeButton={showArchived ? 'right' : 'left'}
            leftLabel="Hide"
            rightLabel="Show"
            onLeftClick={() => setShowArchived(false)}
            onRightClick={() => setShowArchived(true)}
            borderColor="border-main-300"
            buttonHeight="h-f2"
            buttonPadding="pr-f2"
            data-testid="preferences-archived-entries-toggle"
          />
        </div>
      </div>
    </div>
  );
};
